import React from 'react';

const LDAPAdapterDocumentation = () => {
  return (
    <div></div>
  );
};

export default LDAPAdapterDocumentation;
